import * as React from 'react';
import { useParams } from 'react-router';

import { ViewMain } from "./Components/View";
import { Controller } from "./Infraestructure/Controller";

const HomeTotalStock = () => {
    const params = useParams();
    const controller = Controller();

    React.useEffect(() => {
        controller.init();
        return () => {
        }
        // eslint-disable-next-line
    }, []);

    return (<ViewMain
        detalleStockPersonal={controller.detalleStockPersonal}
        codigoLlave={params.codigoLlave || ''}
    />);
};

export default HomeTotalStock;